import axios from "axios";
import { global, globalMenu } from "@shared/libs/Global";

/**
 * 첨부파일 1건의 실제 파일을 내려받는다. (sys_attachfile.id 기준)
 * 문서검색은 다른 모듈의 문서를 함께 조회하므로 cd_module은 행 값이 우선이고,
 * 조회 결과에 없으면 현재 메뉴의 모듈을 사용한다.
 */
export const getAttachFileBlob = async (row: any): Promise<Blob> => {
  const cdModule =
    row?.cd_module || globalMenu.getState().activeMenuInfo.cd_module || "";

  const res = await axios.post(
    "/snotes/file/download",
    { id: row?.id, cdModule: cdModule },
    {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
      responseType: "blob",
    }
  );

  return new Blob([res.data]);
};

/**
 * 첨부파일 1건을 PDF 로 변환해 받는다. (POST /snotes/file/preview)
 * 브라우저가 직접 그릴 수 없는 오피스 문서는 서버가 PDF 로 바꿔 내려준다.
 * 요청 규격은 download 와 동일하고 응답만 application/pdf 다.
 */
export const getAttachFilePreviewBlob = async (row: any): Promise<Blob> => {
  const cdModule =
    row?.cd_module || globalMenu.getState().activeMenuInfo.cd_module || "";

  const res = await axios.post(
    "/snotes/file/preview",
    { id: row?.id, cdModule: cdModule },
    {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
      responseType: "blob",
    }
  );

  return new Blob([res.data], { type: "application/pdf" });
};
